import { GetProductReturns, UpdateProductReturns, UpdateProductReturnType, GetProductTypes, UpdateProductReturnById } from "./actionTypes";
import API from '../../services/requestService';
import ENDPOINT from '../../services/endpoints';
import { Dispatch } from "redux";
import store from "..";
import { showToast, showLoader } from "./common";
import { TOAST_HEADER, MESSAGES } from "../../services/constants";
import { Legend, IColumn, ICard } from "../../shared/models/mainDashboardModel";
import { spread, union}from 'lodash';

export const getProductTypes = () => async (dispatch: Dispatch<any>) => {
    // API to get list of products
    try {
        const { data: response } = await API.get(ENDPOINT.getProducts);
        if (response.isSuccess) {
            dispatch({ type: GetProductTypes, payload: response.data })
        } else {
            dispatch(showToast(TOAST_HEADER.ERROR, response.message));
        }
    } catch (e) {
        console.error('getProductTypes', e);
        dispatch(showLoader(false));
        dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
        return e;
    }
}

export const getProductReturns = () => async (dispatch: Dispatch<any>) => {
    // API to get list of returns
    const { data: response } = await API.get(ENDPOINT.getDashboardData);
    // dispatch({ type: GetProductReturns, payload: initialData.columns })
    response.data.columns.forEach((column: IColumn) => {
        column.id = 'column_' + column.id.toString();
        column.items.forEach((item: ICard) => {
            item.columnId = column.id;
            item.id = 'item_' + item.id.toString();
            item.date = item.date && item.date * 1000;
            // item.timeElapsed= true;
            // item.timeElapsedColor = "#FFBE00"
        })
    });
    dispatch({ type: GetProductReturns, payload: response.data.columns })
}

export const dragAndDrop = (result: any) => async (dispatch: Dispatch<any>) => {
    // reorder column
    const { destination, source, draggableId } = result;
    if (!destination) {
        return;
    }

    if (destination.droppableId === source.droppableId &&
        destination.index === source.index) {
        return;
    }
    // Moving cards in same column
    const columns = [...store.getState().mainDashboard.productReturns];
    const start = columns.find((column: any) => column.id === source.droppableId);
    const finish = columns.find((column: any) => column.id === destination.droppableId);
    if (start && finish) {
        const draggedCard = start.items.find((card: any) => card.id === draggableId)
        if (start.id === finish.id) {
            return;
            // const newCards = Array.from(start.items);
            // newCards.splice(source.index, 1);
            // if (draggedCard) {
            //     newCards.splice(destination.index, 0, draggedCard);
            // }
            // const startIndex = columns.findIndex((column: any) => column.id === source.droppableId);
            // columns[startIndex].items = newCards;
        } else {
        // // Moving cards from one column to other
        const newCards = Array.from(start.items);
        newCards.splice(source.index, 1);
        const startIndex = columns.findIndex((column: any) => column.id === source.droppableId);
        columns[startIndex].items = newCards;

        const finishCards = Array.from(finish.items);
        if (draggedCard) {
            draggedCard.timeElapsed = false;
            draggedCard.timeElapsedColor = '';
            finishCards.splice(destination.index, 0, draggedCard);
        }
        const finishIndex = columns.findIndex((column: any) => column.id === destination.droppableId);
        columns[finishIndex].items = finishCards;
        }
    }

    try {
        const params = {
            id: +draggableId.split('item_')[1],
            fromColumn: +source.droppableId.split('column_')[1],
            toColumn: +destination.droppableId.split('column_')[1],
        }
        const { data: response } = await API.post(ENDPOINT.moveReturnNote, params);
        response.isSuccess ? dispatch({ type: UpdateProductReturns, payload: columns }) :  dispatch(showToast(TOAST_HEADER.ERROR, response.message));
    } catch (e) {
        console.error('dragAndDrop', e);
        dispatch(showLoader(false));
        dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
        return e;
    }
}

export const updateProductReturnType = (columnId: string, cardId: string, value: number) => async (dispatch: Dispatch<any>) => {
    const reduxStore = store.getState();
    const state = reduxStore.mainDashboard;
    try {
        const columnIndex = state.productReturns.findIndex((column: any) => column.id === columnId);
        const cardIndex = state.productReturns[columnIndex].items.findIndex((card: any) => card.id === cardId);
        let oldValue: number[] = state.productReturns[columnIndex].items[cardIndex][Legend[value]];
        const params = {
            id: +cardId.split('item_')[1],
            [Legend[value]]: !oldValue
        }
        const { data: response } = await API.post(ENDPOINT.updateReturnNote, params);
        response.isSuccess &&
            dispatch({
                type: UpdateProductReturnType, payload: {
                    columnIndex,
                    cardIndex,
                    value,
                    oldValue
                }
            });
    } catch (e) {
        console.error('updateProductReturnType', e);
        dispatch(showLoader(false));
        dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
        return e;
    }
}

export const updateProductReturnById = (id: number) => async (dispatch: Dispatch<any>) => {
    const reduxStore = store.getState();
    const state = reduxStore.mainDashboard;

    try {
        const cards: any[] =  spread(union)(state.productReturns.map((columns: IColumn) => columns.items));
        const card = cards.find((card: ICard) => card.id === 'item_'+ id);
        const colPosition = Number(card.columnId.split('_')[1]);
        const cardIndex = state.productReturns[colPosition-1].items.findIndex((card: any) => card.id === 'item_'+id);
        const { data: response } = await API.get(ENDPOINT.getItemById, { params: { id, colPostion:colPosition }});
        if(response.isSuccess) {
        const card = response.data;
        card.id = 'item_' + card.id;
        card.columnId = 'column_'+ colPosition;
        card.date = card.date && card.date * 1000;
        dispatch({
            type: UpdateProductReturnById, payload: {
                    colPosition: colPosition-1,
                    cardIndex,
                    card
            }
        });
        }
    } catch (e) {
        console.error('updateProductReturnById', e);
        dispatch(showLoader(false));
        dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
        return e;
    }
}